import Decision from "./Decision";
import Tag from "./Tag";

export default class Story {
    id:number = 1;
    text:string = "Enter story text here";
    textDecoded:string = "NA";
    currentDecisionId:number = 1;
    canDelete:boolean = true;
    decisions:Array<Decision> = [new Decision()];
    multiselect:boolean = true;
    onceOnly:boolean = false;
    tags:Array<Tag> = [];
}



// WEBPACK FOOTER //
// ./src/objects/Story.ts